import React, { useState, useEffect, useCallback, useMemo } from 'react';
import QRCode from 'react-qr-code';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  ButtonBase,
  Box,
  useMediaQuery,
} from '@material-ui/core';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { ExpandMore, ThumbUp, ThumbDown } from '@material-ui/icons';
// import { Alert } from '@material-ui/lab';
import {
  isArray,
  assign,
  isEmpty,
  reduce,
  includes,
  isUndefined,
  isNull,
} from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import {
  Form as FormUI,
  Autocomplete,
  Input,
  DateTime,
  Select,
  Hidden,
} from '~/components/Form';
import { ONLINE } from '~/constants/default';
import {
  CUSTOMIZACAO_RAIZEN,
  MODULONFE,
  SKID,
  MODULOFOTO,
} from '~/constants/modules';
import { t, number, can, removerMascaraCNPJ } from '~/helpers';
import api from '~/services/api';

import DeleteButtonWithModal from '../DeleteButtonWithModal';
import PesquisaTabelaInput from '../PesquisaTabelaInput';
import TabelaRecebimento from '../Table';
import TableBatch from '../TableBatch';
import TableCompartments from '../TableCompartments';
import {
  RECEBIMENTO_READ_ONLY,
  RECEBIMENTO_SELECT_TANKS,
  RECEBIMENTO_WAIT_FINISH,
} from './constantes';
import defaultInitial from './initialState';
import defaultInitialXML from './initialStateXML';
import * as S from './styles';

const useStyles = makeStyles({
  table: {
    maxWidth: 650,
  },
});

const Form = React.forwardRef((props, ref) => {
  const { onCloseModal, formEdit } = props;

  const history = useHistory();
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // 05-05-2025  novo para visualizar
  console.log(JSON.stringify(props));
  const isFinalizado = Number(formEdit?.finalizadadescarganf) === 1;
  console.log(JSON.stringify(isFinalizado));

  const token = useSelector((state) => state.auth);

  const initial = assign({}, defaultInitial);
  const initialXML = assign({}, defaultInitialXML);

  const classes = useStyles();

  const formRef = React.useRef(null);
  const formRefXML = React.useRef(null);

  const { client, id } = useSelector((state) => state.user.profile);

  const {
    controlanfeclienteconfig,
    permitirselecionarmaisdeumtanquenorecebimentoclienteconfig,
    permitirselecionarmaisdeumcompartimentonorecebimentoclienteconfig,
    permitirrecebimentosemumxmlnosistemaclienteconfig,
  } = useSelector((state) => state.user.configs);

  const [initials, setInitials] = useState({});

  const [initialXMLs, setInitialXMLs] = useState({});

  const [receivement, setReceivement] = useState(2);
  const [open, setOpen] = useState(false);
  const [openConfirmaInicio, setOpenConfirmaInicio] = useState(false);
  const [openConfirmaFim, setOpenConfirmaFim] = useState(false);

  const [volume, setVolume] = useState(Number(initial.volumenfdescarganf));
  const [price, setPrice] = useState(Number(initial.precounitariodescarganf));

  const [volumeXML, setVolumeXML] = useState(
    Number(initialXML.volumenfdescarganf)
  );
  const [priceXML, setPriceXML] = useState(
    Number(initialXML.precounitariodescarganf)
  );

  const [expanded, setExpanded] = useState('nf');
  const [tanques, setTanques] = useState([]);
  const [statusRecebimento, setStatusRecebimento] = useState(0);
  const [typeTank, setTypeTank] = useState(0); // 2
  const [diffTank, setDiffTank] = useState(0);
  const [loading, setLoading] = useState(false);
  const [resumoVolAbs, setResumoBolAbs] = useState(0);
  const [load, setLoad] = useState(false);

  const [habOper20, setHabOper20] = useState(false);

  const [habCompartments, setHabCompartments] = useState(false);
  const [
    habOperamostracompartimentossemreceb20,
    setOperamostracompartimentossemreceb20,
  ] = useState(false);

  const [habReceipt, setHabReceipt] = useState(false);
  const [
    habHabilitafotonotafiscalposto,
    setHabHabilitafotonotafiscalposto,
  ] = useState(false);
  const [
    habilitaInspesaoDescargaPosto,
    setHabilitaInspesaoDescargaPosto,
  ] = useState(false);

  const [statusHabilitaSkidPosto, setStatusHabilitaSkidPosto] = useState(false);

  const [calculodensidadeproduto, setCalculodensidadeproduto] = useState(0);
  const [volume20, setVolume20] = useState(
    Number(initial.volume20nftbdescarganf)
  );
  const [densidade20NF, setDensidade20NF] = useState(
    Number(initial.densidade20nftbdescarganf)
  );
  const [temperaturaNF, setTemperaturaNF] = useState(
    Number(initial.temperaturanftbdescarganf)
  );
  const [numberCompartments, setNumberCompartments] = useState(
    can(SKID) ? 1 : 0
  );
  const [compartimentos, setCompartimentos] = useState([]);

  const [inspecao, setInspecao] = useState({});

  const [
    densidadecalculadaamostra20,
    setDensidadecalculadaamostra20,
  ] = useState(0.0);

  const [densidadeamostra, setDensidadeamostra] = useState(0.0);
  const [temperaturaamostra, setTemperaturaamostra] = useState(0.0);

  // Alertar que tem que salvar!
  const [necessarioBtnSalvar, setNecessarioBtnSalvar] = useState(false);

  const [habilitaDtaCampoInicio, setHabilitaDtaCampoInicio] = useState(true);
  const [habilitaDtaCampoFim, setHabilitaDtaCampoFim] = useState(false);

  const [tokenUuidDescarganf, setTokenUuidDescarganf] = useState(
    initials.tokenuuiddescarganf
  );
  const [jatiroufotodescarganf, setJatiroufotodescarganf] = useState(
    initials.jatiroufotodescarganf
  );
  const [dataFotos, setDataFotos] = useState([]);

  const [iddescarganfgeral, setIddescarganfgeral] = useState(null);
  const [idpostogeral, setIdpostogeral] = useState(null);

  const [tokenws, setTokenWs] = useState(null);
  const [ws, setWs] = useState(null);
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState('');

  /*
    'naoLeuNF',
    'leuUmaNF',
    'leuMaisDeUmaNF',
    'leuNFManual',
  */
  const [statusLeituraNF, setStatusLeituraNF] = useState('');

  const [openAceitaSemNotaFiscal, setOpenAceitaSemNotaFiscal] = useState(false);
  const [leuNF, setLeuNF] = useState(false);

  const [desabilitaClearInputAtive, setDesabilitaClearInputAtive] = useState(
    false
  );

  // const [nfdescarganf, setNfdescarganf] = useState('');
  const [nfdescarganf, setNfdescarganf] = useState(initials.nfdescarganf);

  const [objNf, setObjNf] = useState({});

  const [idnfedescarganf, setIdnfedescarganf] = useState('');

  const [version, setVersion] = useState('version4'); // version6 ; version4

  const [leuIdnfedescarganf, setLeuIdnfedescarganf] = useState(false);

  // Total price
  const total = React.useMemo(() => Number(volume * price), [volume, price]);

  const totalXML = React.useMemo(() => Number(volumeXML * priceXML), [
    volumeXML,
    priceXML,
  ]);

  // Skid
  const [skid, setSkid] = useState(null);
  // Skid - dados dinamicos
  const [dataSkid, setDataSkid] = useState([]);
  const [volumeSkid, setVolumeSkid] = useState(0);
  const [volume20Skid, setVolume20Skid] = useState(0);
  const [temperaturaSkid, setTemperaturaSkid] = useState(0);
  const [densidadeSkid, setDensidadeSkid] = useState(0);

  const [cnpjPosto, setCnpjPosto] = useState('0');
  const [codigoPosto, setCodigoPosto] = useState(0);
  const [nomePosto, setNomePosto] = useState('');

  const appUrl = `${window.location.host}/fotonf?id=${
    initials?.tokenuuiddescarganf
  }&token=${JSON.stringify(token?.token).replace(/^["']|["']$/g, '')}`;

  const irParaFotoNF = () => {
    const id = `id=${initials?.tokenuuiddescarganf}&token=${JSON.stringify(
      token?.token
    ).replace(/^["']|["']$/g, '')}`;
    history.push(`/fotonflocal?${id}`);
  };

  const tanquesVolumeRec = React.useMemo(
    () =>
      reduce(
        tanques.map(
          (tanque) =>
            tanque.volumefinaldescarganftanque -
            tanque.volumeinicialdescarganftanque
        ),
        (sum, n) => sum + n,
        0
      ),
    [tanques]
  );

  const diffNFMed = React.useMemo(() => {
    const v = Number(initials.volumenfdescarganf || volume);
    return Math.abs(Number((tanquesVolumeRec + resumoVolAbs - v) / v) * 100);
  }, [tanquesVolumeRec, resumoVolAbs, initials.volumenfdescarganf, volume]);

  // Open Modal
  const openModal = React.useCallback(() => {
    setOpen(true);
  }, []);

  // Close Modal
  const closeModal = React.useCallback(() => {
    setOpen(false);
    setInitials({});
    setInitialXMLs({});
  }, []);

  const handleCallbackClose = React.useCallback(() => {
    onCloseModal();
  }, []);

  const handleOpenConfirmaInicio = React.useCallback(
    () => setOpenConfirmaInicio(true),
    []
  );

  const handleCloseConfirmaInicio = React.useCallback(
    () => setOpenConfirmaInicio(false),
    []
  );

  const handleOpenConfirmaFim = React.useCallback(
    () => setOpenConfirmaFim(true),
    []
  );

  const handleCloseConfirmaFim = React.useCallback(
    () => setOpenConfirmaFim(false),
    []
  );

  const handleAtualizaTanques = (dadosTanques) => {
    setTanques(Object.assign([], dadosTanques));
  };

  const atualizaStatusRecebimento = (values) => {
    let retorno = RECEBIMENTO_READ_ONLY; // indica que a tabela não pode ser editada nem atualizada
    const items = values || initials;

    if (
      items.datahoradescarganf !== null &&
      items.datacapturainiciodescarganf === null
    ) {
      // Indica que a tabela deve exibir o checkbox para que o usuário escolha os tanques e digite os valores iniciais
      retorno = RECEBIMENTO_SELECT_TANKS;
    }

    if (
      items.datacapturainiciodescarganf !== null &&
      items.datacapturafimdescarganf === null
    ) {
      // indica que o ínicio já foi capturado e que devem ser digitados os valores finais
      retorno = RECEBIMENTO_WAIT_FINISH;
    }

    setStatusRecebimento(retorno);
  };

  const handleAtualizaCompartimentos = (dadosCompartimentos) => {
    setCompartimentos(Object.assign([], dadosCompartimentos));
    if (expanded === 'compartments') {
      setNecessarioBtnSalvar(true);
    }
    setInitials((state) => ({
      ...state,
      compartimentos: dadosCompartimentos,
    }));
  };

  const handleTestVolume20 = useCallback((value) => {
    const regex1 = /^((\d+\,\d+){1})$/;
    const regex2 = /^(\d+)$/;
    const regex3 = /^((\d+\.\d+){1})$/;

    if (isEmpty(value)) {
      return false;
    }

    if (Number(value) <= 0) {
      return false;
    }

    if (
      regex1.test(value) ||
      regex2.test(value) ||
      regex3.test(value) ||
      isEmpty(value)
    ) {
      return true;
    }

    return false;
  }, []);

  const handleTestCompartimentoAmostraDescarganf = useCallback(
    (value) => {
      if (isEmpty(value)) {
        toast.error(`Valor inválido para campo compartimentos amostra!`);
        return false;
      }
      if (Number(value) <= 0) {
        toast.error(`Valor inválido para campo compartimentos amostra!`);
        return false;
      }
      if (Number(value) > numberCompartments) {
        toast.error(
          `Valor máxima permitido para campo compartimentos amostra ${numberCompartments}`
        );
        return false;
      }
      return true;
    },
    [numberCompartments, expanded]
  );

  const handleTestTemperaturaAmostraDescarganf = useCallback(
    (value) => {
      if (isEmpty(value)) {
        toast.error(`Valor inválido para campo temperatura amostra!`);
        return false;
      }
      if (Number(value) <= 0) {
        toast.error(`Valor inválido para campo temperatura amostra!`);
        return false;
      }
      if (Number(value) > 99) {
        toast.error(`Valor inválido para campo temperatura amostra!`);
        return false;
      }
      return true;
    },
    [expanded]
  );

  const handleTestDensidadeAmbienteAmostraDescarganf = useCallback(
    (value) => {
      if (isEmpty(value)) {
        toast.error(`Valor inválido para campo densidade ambiente amostra!`);
        return false;
      }
      if (Number(value) <= 0) {
        toast.error(`Valor inválido para campo densidade ambiente amostra!`);
        return false;
      }
      if (Number(value) > 99) {
        toast.error(`Valor inválido para campo densidade ambiente amostra!`);
        return false;
      }
      return true;
    },
    [expanded]
  );

  const handleTestDensidade20AmostraDescarganf = useCallback(
    (value) => {
      if (isEmpty(value)) {
        toast.error(`Valor inválido para campo densidade 20 amostra!`);
        return false;
      }
      if (Number(value) <= 0) {
        toast.error(`Valor inválido para campo densidade 20 amostra!`);
        return false;
      }
      if (Number(value) > 99) {
        toast.error(`Valor inválido para campo densidade 20 amostra!`);
        return false;
      }
      return true;
    },
    [expanded]
  );

  const getValidationCompartmentsSchema = (
    habCompartments,
    permitirMaisDeUm
  ) => {
    const maxCompartimentos = permitirMaisDeUm ? 16 : 1;

    return Yup.object().shape({
      numerocompartimentosdescarganf: habCompartments
        ? Yup.number()
            .typeError(t('s.geral.validacao.tiponumerico'))
            .required(t('s.geral.validacao.campoobrigatorio'))
            .min(1, t('s.geral.validacao.tamanhominimo').replace('%s', 1))
            .max(
              maxCompartimentos,
              t('s.geral.validacao.tamanhomaximo').replace(
                '%s',
                maxCompartimentos
              )
            )
        : Yup.string().nullable(),
    });
  };

  // Schema Validade
  const schemaValidade = React.useMemo(
    () =>
      Yup.object().shape({
        idposto: Yup.string()
          .transform((value, originalValue) =>
            originalValue === '' || originalValue === null ? undefined : value
          )
          .required(t('s.geral.validacao.campoobrigatorio')),
        // idposto: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        idproduto: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        cnpjdistribuidoradescarganf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(15, t('s.geral.validacao.tamanhomaximo').replace('%s', 15)),
        cnpjtransportadoradescarganf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(15, t('s.geral.validacao.tamanhomaximo').replace('%s', 15)),

        numeropedidodescarganf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(
            can(CUSTOMIZACAO_RAIZEN) ? 10 : 15,
            t('s.geral.validacao.tamanhomaximo').replace(
              '%s',
              can(CUSTOMIZACAO_RAIZEN) ? 10 : 15
            )
          ),
        nfdescarganf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(
            can(CUSTOMIZACAO_RAIZEN) ? 10 : 15,
            t('s.geral.validacao.tamanhomaximo').replace(
              '%s',
              can(CUSTOMIZACAO_RAIZEN) ? 10 : 15
            )
          ),
        dataemissaonfdescarganf: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        placactdescarganf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10)),
        motoristadescarganf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(30, t('s.geral.validacao.tamanhomaximo').replace('%s', 30)),
        volumenfdescarganf: Yup.number().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        precounitariodescarganf: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
      }),
    [
      typeTank,
      statusRecebimento,
      RECEBIMENTO_WAIT_FINISH,
      habilitaDtaCampoFim,
      habCompartments,
      habilitaInspesaoDescargaPosto,
      calculodensidadeproduto,
      habReceipt,
      numberCompartments,
      nfdescarganf,
      permitirselecionarmaisdeumcompartimentonorecebimentoclienteconfig,
      habOper20,
    ]
  );

  // Busca dados do volume abastecido
  const handleGetSummaryVL = React.useCallback(async (nf, tank) => {
    try {
      setLoad(true);
      const response = await api.get(`descargasnfs/volumesaida/${nf}/${tank}`);
      setResumoBolAbs(response.data.volumesaidadescarganftanque);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoad(false);
    }
  }, []);

  // Submit form
  const handleSubmit = React.useCallback(
    async (data) => {
      try {
        data.idposto = formEdit.idposto;

        if (
          data.numeropedidodescarganf === undefined ||
          data.numeropedidodescarganf === null ||
          data.numeropedidodescarganf === ''
        ) {
          data.numeropedidodescarganf = formEdit.numeropedidodescarganf;
        }

        if (
          data.motoristadescarganf === undefined ||
          data.motoristadescarganf === null ||
          data.motoristadescarganf === ''
        ) {
          data.motoristadescarganf = formEdit.motoristadescarganf;
        }

        console.log(JSON.stringify(formEdit));
        console.log(JSON.stringify(data));
        console.log(JSON.stringify(initialXMLs));
        console.log(JSON.stringify(objNf));

        await schemaValidade.validate(data, {
          abortEarly: false,
        });

        if (formEdit.idproduto !== data.idproduto) {
          toast.error('Produto diferente do recebido!');
          return;
        }

        if (formEdit.volumenfdescarganf !== data.volumenfdescarganf) {
          toast.error('Volume diferente do recebido!');
          return;
        }

        data.precototaldescarganf = total;
        data.idcliente = client;
        data.idusuario = id;
        data.precounitariodescarganf = Number(data.precounitariodescarganf);
        data.volumenfdescarganf = Number(data.volumenfdescarganf);
        data.tipodescarganf = data.tipodescarganf ?? null;

        data.comnfedescarganf = 'S';

        const modifyData = assign(initials, data);

        if (Number(data.tipodescargaposto) === 2) {
          delete modifyData.tipodescargaposto;

          try {
            setLoad(true);
            await api.post('descargasnfs', modifyData);
            toast.success(t('s.operacao.recebimentonf.recebimentorealizado'));

            setInitials({});
            setInitialXMLs({});

            closeModal();
          } catch (err) {
            if (isArray(err)) err.map((e) => toast.error(t(e)));
            else toast.error(t(err));
          } finally {
            setLoad(false);
          }
        } else {
          delete modifyData.tipodescargaposto;

          try {
            setLoad(true);
            const response = await api.put(
              'descargasnfs/salvaConciliarXML',
              modifyData
            );
            toast.success(t('s.operacao.recebimentonf.dadosnfsalvo'));

            setIddescarganfgeral(response.data.iddescarganf);
            setIdpostogeral(response.data.idposto);
            setTokenUuidDescarganf(response.data.tokenuuiddescarganf);
            setTokenWs(response.data.tokenuuiddescarganf);
            // console.log(JSON.stringify(response));

            setReceivement(Number(data.tipodescargaposto || receivement));
            setInitials(assign(initials, response.data));
            setExpanded('tank');

            if (isEmpty(tanques)) {
              setTanques(initials.tanques);
            }

            if (isEmpty(compartimentos)) {
              setCompartimentos(initials.compartimentos);
            }

            if (isEmpty(inspecao)) {
              setInspecao(initials.inspecao);
            }

            atualizaStatusRecebimento();
          } catch (err) {
            if (isArray(err)) err.map((e) => toast.error(t(e)));
            else toast.error(t(err));
          } finally {
            setLoad(false);
          }
        }

        if (!isEmpty(initials) && initials.finalizadadescarganf === 1) {
          closeModal();
        }
      } catch (err) {
        // console.log(JSON.stringify(err))

        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          formRefXML.current.setErrors(validationErrors);

          if (validationErrors.hasOwnProperty('datahorafimdescarganf')) {
            setExpanded('nf');
          } else if (
            validationErrors.hasOwnProperty(
              'inspecao.inpsdatasaidabdescarganfinspecao'
            )
          ) {
            setExpanded('Inspection');
          }
          // setExpanded('nf');
        }
      }
    },
    [
      receivement,
      initials,
      typeTank,
      statusRecebimento,
      RECEBIMENTO_WAIT_FINISH,
      tanques,
      habilitaDtaCampoFim,
      statusLeituraNF,
      nfdescarganf,
      inspecao,
      initialXMLs,
      formEdit,
      objNf,
    ]
  );

  // Change Accordion
  const handleChangeAccordion = React.useCallback(
    (value) => {
      if (receivement !== 2) setExpanded(value === expanded ? null : value);
    },
    [expanded, receivement]
  );

  const handleGetDadosFotos = useCallback(async (iddescarganf, idposto) => {
    try {
      const response = await api.get(
        `descargasnfs/fotos/${iddescarganf}/${idposto}`
      );
      setDataFotos(response.data);
    } catch (err) {
      setDataFotos([]);
      err.map((e) => toast.error(e));
    } finally {
    }
  }, []);

  const handleDeleteFotos = useCallback(async (iddescarganf, idposto) => {
    try {
      setLoading(true);
      const response = await api.delete(
        `descargasnfs/fotos/${iddescarganf}/${idposto}`
      );

      if (
        response?.status === 200 ||
        response?.status === 201 ||
        response?.status === 202
      ) {
        setJatiroufotodescarganf(true);
      } else {
        toast.error(response?.data);
      }
      // console.log(JSON.stringify(response));

      // handleCallbackClose();
    } catch (err) {
      err.map((e) => toast.error(e));
    } finally {
      setLoading(false);
    }
  }, []);

  // Load form edit
  const handleGetEditForm = React.useCallback(async (descarga, produto) => {
    setLoading(true);

    // console.log('handleGetEditForm');
    try {
      setLoad(true);

      const retorno = await api.get(`descargasnfs/${descarga}/${produto}`);

      const data = retorno?.data;

      // const { data } = await api.get(`descargasnfs/${descarga}/${produto}`);
      setInitials(data);

      setInitialXMLs(data);

      setVolume20(data.volume20nftbdescarganf);

      setVolume(data.volumenfdescarganf);

      // console.log(JSON.stringify(data?.inspecao));

      // calculodensidadeproduto

      setTokenWs(data.tokenuuiddescarganf);

      if (!isEmpty(data.tanques)) {
        await setReceivement(1);
        await setTanques(data.tanques);
      }

      if (!isEmpty(data.compartimentos)) {
        await setCompartimentos(data.compartimentos);
      }

      if (!isEmpty(data.inspecao)) {
        await setInspecao(data.inspecao);
      }

      setNfdescarganf(data.nfdescarganf);

      setTokenUuidDescarganf(data.tokenuuiddescarganf);
      setJatiroufotodescarganf(data.jatiroufotodescarganf);

      setDensidadecalculadaamostra20(data.densidade20amostradescarganf);

      await atualizaStatusRecebimento(data);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
      setLoad(false);
    }
  }, []);

  // Export functions
  React.useImperativeHandle(ref, () => ({
    openModal,
  }));

  React.useEffect(() => {
    if (!isEmpty(formEdit)) {
      const { iddescarganf, idposto } = formEdit;
      setIddescarganfgeral(iddescarganf);
      setIdpostogeral(idposto);
      handleGetEditForm(iddescarganf, idposto);
      if (can(MODULOFOTO)) {
        handleGetDadosFotos(iddescarganf, idposto);
      }
    }
  }, [formEdit, MODULOFOTO]);

  React.useEffect(() => {
    setInitials({
      iddescarganf: 0,
      idcliente: 0,
      idposto: 0,
      idproduto: 0,
      cnpjdistribuidoradescarganf: '',
      cnpjtransportadoradescarganf: '',
      idusuario: 0,
      datahoradescarganf: null,
      datahorainiciodescarganf: null,
      datahorafimdescarganf: null,
      datadadosnfdescarganf: null,
      datacapturainiciodescarganf: null,
      datacapturafimdescarganf: null,
      numeropedidodescarganf: '',
      nfdescarganf: '',
      dataemissaonfdescarganf: null,
      placactdescarganf: '',
      motoristadescarganf: '',
      volumenfdescarganf: 0.0,
      precounitariodescarganf: 0.0,
      precototaldescarganf: 0.0,
      temperaturaamostratbdescarganf: 0.0,
      densidadeambienteamostratbdescarganf: 0.0,
      densidade20tbdescarganf: 0.0,
      temperaturanftbdescarganf: 0.0,
      densidade20nftbdescarganf: 0.0,
      volume20nftbdescarganf: 0.0,
      finalizadadescarganf: 0,
      compartimentos: [],
      tanques: [],
      inspecao: {},

      comnfedescarganf: 'N',
    });

    setInitialXMLs({
      iddescarganf: 0,
      idcliente: 0,
      idposto: 0,
      idproduto: 0,
      cnpjdistribuidoradescarganf: '',
      cnpjtransportadoradescarganf: '',
      idusuario: 0,
      datahoradescarganf: null,
      datahorainiciodescarganf: null,
      datahorafimdescarganf: null,
      datadadosnfdescarganf: null,
      datacapturainiciodescarganf: null,
      datacapturafimdescarganf: null,
      numeropedidodescarganf: '',
      nfdescarganf: '',
      dataemissaonfdescarganf: null,
      placactdescarganf: '',
      motoristadescarganf: '',
      volumenfdescarganf: 0.0,
      precounitariodescarganf: 0.0,
      precototaldescarganf: 0.0,
      temperaturaamostratbdescarganf: 0.0,
      densidadeambienteamostratbdescarganf: 0.0,
      densidade20tbdescarganf: 0.0,
      temperaturanftbdescarganf: 0.0,
      densidade20nftbdescarganf: 0.0,
      volume20nftbdescarganf: 0.0,
      finalizadadescarganf: 0,
      compartimentos: [],
      tanques: [],
      inspecao: {},

      comnfedescarganf: 'N',
    });
  }, []);

  const compartimentosVolume20Rec = React.useMemo(
    () =>
      reduce(
        compartimentos.map(
          (compartimento) => compartimento.volume20descarganfcompartimento
        ),
        (sum, n) => sum + n,
        0
      ),
    [compartimentos]
  );

  const compartimentosVolumeRec = React.useMemo(
    () =>
      reduce(
        compartimentos.map(
          (compartimento) =>
            compartimento.volumedeclaradodescarganfcompartimento
        ),
        (sum, n) => sum + n,
        0
      ),
    [compartimentos]
  );

  // Calcula a densidade da amostra
  const handleGetConverteDensidadePara20Graus = React.useCallback(async () => {
    if (
      densidadeamostra > 0 &&
      temperaturaamostra > 0 &&
      calculodensidadeproduto > 0
    ) {
      try {
        const response = await api.get(
          `/calculodensidades/converteDensidadePara20Graus/${densidadeamostra}/${temperaturaamostra}/${calculodensidadeproduto}`
        );
        formRef.current.setFieldValue(
          'densidade20amostradescarganf',
          response.data.densidade20
        );
        setDensidadecalculadaamostra20(response.data.densidade20);
        if (
          !response.data.temperaturaAmbienteValida ||
          !response.data.densidade20Valida ||
          !response.data.densidadeAmbienteValida
        ) {
          const validationErrors = {
            densidadeambienteamostratbdescarganf:
              response.data.msgErroDensidadeAmbiente,
            temperaturaamostratbdescarganf:
              response.data.msgErroTemperaturaAmbiente,
            densidade20amostradescarganf:
              response.data.densidade20 === 0
                ? 'Não é uma densidade válida!'
                : '',
          };
          if (formRef) {
            if (formRef.current) {
              formRef.current.setErrors(validationErrors);
            }
          }
        } else if (formRef) {
          if (formRef.current) {
            formRef.current.setErrors({});
          }
        }
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      } finally {
      }
    } else {
      setDensidadecalculadaamostra20(0);
    }
  }, [
    temperaturaamostra,
    densidadeamostra,
    calculodensidadeproduto,
    compartimentosVolumeRec,
    compartimentosVolume20Rec,
    volume,
  ]);

  // Calcula a volume 20 compartimento
  const handleGetVolumeNFPara20Graus = React.useCallback(
    async (
      densidadeamostra20,
      temperaturaamostra,
      volumeambiente,
      calculodensidadeproduto
    ) => {
      if (
        densidadeamostra20 > 0 &&
        temperaturaamostra > 0 &&
        volumeambiente > 0 &&
        calculodensidadeproduto > 0
      ) {
        try {
          const { data } = await api.get(
            `/calculodensidades/converteVolumePara20Graus/${densidadeamostra20}/${temperaturaamostra}/${volumeambiente}/${calculodensidadeproduto}`
          );

          const valor = Number(data.volume20).toFixed(1);

          const {
            densidade20Valida,
            densidadeAmbienteValida,
            temperaturaAmbienteValida,
            msgErroDensidadeAmbiente,
            msgErroTemperaturaAmbiente,
          } = data;

          if (
            String(msgErroDensidadeAmbiente).length > 0 &&
            String(msgErroTemperaturaAmbiente).length > 0
          ) {
            const validationErrorsErroDensidadeAmbiente = {
              densidade20nftbdescarganf: msgErroDensidadeAmbiente,
              temperaturanftbdescarganf: msgErroTemperaturaAmbiente,
            };
            if (formRef) {
              if (formRef.current) {
                formRef.current.setErrors(
                  validationErrorsErroDensidadeAmbiente
                );
              }
            }
          } else {
            if (String(msgErroDensidadeAmbiente).length > 0) {
              const validationErrorsErroDensidadeAmbiente = {
                densidade20nftbdescarganf: msgErroDensidadeAmbiente,
              };
              if (formRef) {
                if (formRef.current) {
                  formRef.current.setErrors(
                    validationErrorsErroDensidadeAmbiente
                  );
                }
              }
            }

            if (String(msgErroTemperaturaAmbiente).length > 0) {
              const validationErrorsmsgErroTemperaturaAmbiente = {
                temperaturanftbdescarganf: msgErroTemperaturaAmbiente,
              };
              if (formRef) {
                if (formRef.current) {
                  formRef.current.setErrors(
                    validationErrorsmsgErroTemperaturaAmbiente
                  );
                }
              }
            }
          }

          return valor;
        } catch (err) {
          if (isArray(err)) err.map((e) => toast.error(t(e)));
          else toast.error(t(err));
        } finally {
        }
      } else {
      }
    },
    []
  );

  // Calcula a volume 20 compartimento
  const handleGetVolumePara20Graus = React.useCallback(
    async (
      densidadeamostra20,
      temperaturaamostra,
      volumeambiente,
      calculodensidadeproduto
    ) => {
      if (
        densidadeamostra20 > 0 &&
        temperaturaamostra > 0 &&
        volumeambiente > 0 &&
        calculodensidadeproduto > 0
      ) {
        try {
          const { data } = await api.get(
            `/calculodensidades/converteVolumePara20Graus/${densidadeamostra20}/${temperaturaamostra}/${volumeambiente}/${calculodensidadeproduto}`
          );

          const valor = Number(data.volume20).toFixed(1);

          return valor;
        } catch (err) {
          if (isArray(err)) err.map((e) => toast.error(t(e)));
          else toast.error(t(err));
        } finally {
        }
      } else {
      }
    },
    []
  );

  useEffect(() => {
    if (compartimentos)
      handleChangeVolumeDeclaradoCompartimentos(compartimentos);
  }, [densidadecalculadaamostra20, calculodensidadeproduto]);

  const handleChangeVolumeDeclaradoCompartimentos = React.useCallback(
    async (compartimentos) => {
      let listaDeCompartimentosAux = [];

      listaDeCompartimentosAux = Object.assign([], compartimentos);

      for (let idx = 0; idx < listaDeCompartimentosAux.length; idx++) {
        if (
          listaDeCompartimentosAux[idx].temperaturadescarganfcompartimento >
            0 &&
          listaDeCompartimentosAux[idx].volumedeclaradodescarganfcompartimento >
            0
        ) {
          const valor20 = await handleGetVolumePara20Graus(
            densidadecalculadaamostra20,
            listaDeCompartimentosAux[idx].temperaturadescarganfcompartimento,
            listaDeCompartimentosAux[idx]
              .volumedeclaradodescarganfcompartimento,
            calculodensidadeproduto
          );

          listaDeCompartimentosAux[
            idx
          ].volume20descarganfcompartimento = Number(valor20);
        } else {
          listaDeCompartimentosAux[idx].volume20descarganfcompartimento = 0;
        }
        handleAtualizaCompartimentos(listaDeCompartimentosAux);
      }
    },
    [densidadecalculadaamostra20, calculodensidadeproduto]
  );

  const handleChangeVolume20NF = React.useCallback(async () => {
    // console.log(densidade20NF);
    // console.log(temperaturaNF);
    // console.log(volume);
    // console.log(calculodensidadeproduto);

    if (
      densidade20NF > 0 &&
      temperaturaNF > 0 &&
      volume > 0 &&
      !isUndefined(calculodensidadeproduto)
    ) {
      let valor20 = await handleGetVolumeNFPara20Graus(
        densidade20NF,
        temperaturaNF,
        volume,
        calculodensidadeproduto
      );

      if (isNull(valor20)) {
        valor20 = 0.0;
      }

      setInitials((state) => ({
        ...state,
        volume20nftbdescarganf: Number(valor20),
      }));

      setVolume20(Number(valor20));

      if (formRef.current) {
        await formRef.current.setFieldValue(
          'volume20nftbdescarganf',
          Number(valor20)
        );
      }
    } else if (formRef.current) {
      // console.log('setFieldValue volume20nftbdescarganf);')
      formRef.current.setFieldValue('volume20nftbdescarganf', '0.0');
      setVolume20(0);
      setInitials((state) => ({
        ...state,
        volume20nftbdescarganf: 0.0,
      }));
    }
  }, [densidade20NF, temperaturaNF, volume, calculodensidadeproduto]);

  const handleLimpaVolume20NF = React.useCallback(async () => {
    if (formRef.current) {
      await formRef.current.setFieldValue('volume20nftbdescarganf', '0.0');
    }
  }, []);

  useEffect(() => {
    // console.log('handleChangeVolume20NF')
    handleChangeVolume20NF();
  }, [densidade20NF, temperaturaNF, volume, calculodensidadeproduto]);

  useEffect(() => {
    handleGetConverteDensidadePara20Graus();
  }, [temperaturaamostra, densidadeamostra, calculodensidadeproduto]);

  // ******
  // ******
  // validar dagno 2025 nfe
  /*
   'naoLeuNF',
   'leuUmaNF',
   'leuMaisDeUmaNF',
   'leuNFManual',
 */
  useEffect(() => {
    // if (((!isEmpty(nfdescarganf)) && (statusLeituraNF === 'leuUmaNF'))
    //   || (statusLeituraNF === 'leuNFManual')) {
    if (!isEmpty(nfdescarganf) && statusLeituraNF === 'leuNFManual') {
      setLeuNF(true);
    }

    // if ((!isEmpty(nfdescarganf)) && (statusLeituraNF === 'leuNFManual')) {
    //   setLeuNF(true);
    // } else {
    //   setLeuNF(false);
    // }
  }, [nfdescarganf, statusLeituraNF]);

  const handleCloseAceitaSemNotaFiscal = React.useCallback(
    () => setOpenAceitaSemNotaFiscal(false),
    []
  );

  const handleConfirmaAceitaSemNotaFiscal = React.useCallback(async () => {
    setStatusLeituraNF('leuNFManual');
    handleCloseAceitaSemNotaFiscal();
  }, []);

  const nfeHeading = useMemo(
    () => [
      {
        id: 'nfnfe',
        label: t('s.operacao.notafiscalrecebida.nfnfe'),
        filter: { type: 'text' },
      },
      {
        id: 'idprodutonscastr',
        label: t('s.operacao.notafiscalrecebida.idprodutonscastr'),
        filter: { type: 'text' },
      },
      {
        id: 'cnpjdistribuidoranfe',
        label: t('s.operacao.notafiscalrecebida.cnpjdistribuidoranfe'),
        filter: { type: 'text' },
      },
      {
        id: 'qcomnfe',
        label: t('s.operacao.notafiscalrecebida.qcomnfe'),
        align: 'right',
        formatted: (value) => number(value, 1),
      },
      {
        id: 'emissaonfe',
        label: t('s.operacao.notafiscalrecebida.emissaonfe'),
        formatted: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
      },
    ],
    []
  );

  const handleInputAceitaSemNotaFiscal = useCallback(
    async (value) => {
      // console.log('handleInputAceitaSemNotaFiscal');
      if (value) {
        if (!isEmpty(cnpjPosto) && cnpjPosto !== '0') {
          await handleVerificarNFEOutroDestinatario(String(value));

          // setNfdescarganf(value);
          // setOpenAceitaSemNotaFiscal(true)
          // await formRef.current.setFieldValue('nfdescarganf', value);
        } else {
          toast.error('O cnpj do posto é obrigatorio!');
        }
      }
    },
    [cnpjPosto]
  );

  const handleInputLimpoNotaFiscal = useCallback(() => {
    setNfdescarganf('');
    setStatusLeituraNF('');
    // setStatusLeituraNF('naoLeuNF');
    setCalculodensidadeproduto(0);
    // setHabCompartments(false);

    // setVolume(0);
    // setPrice(0);
    // console.log('handleInputLimpoNotaFiscal');

    setLeuNF(false);
    // console.log('handleInputLimpoNotaFiscal');
  }, []);

  const handlePostoCnpj = useCallback(async (value) => {
    // console.log('handlePostoCnpj');
    let cnpj = '';
    setNfdescarganf('');
    // setNfdescarganf(null);
    setStatusLeituraNF('');
    setLeuNF(false);
    setDesabilitaClearInputAtive(true);
    if (!isUndefined(value) && !isEmpty(value)) {
      cnpj = removerMascaraCNPJ(value);
    } else {
      cnpj = '0';
    }
    setCnpjPosto(cnpj);
  }, []);

  const handleallbackDesabilitaClearInputAtive = useCallback(async () => {
    // console.log('handleallbackDesabilitaClearInputAtive');
    setDesabilitaClearInputAtive(false);
  }, []);

  const handleInputNotaFiscal = useCallback((value) => {
    // console.log('handleInputNotaFiscal');
    if (value) {
      setStatusLeituraNF('leuUmaNF');
      setNfdescarganf(String(value.nfnfe));
      setObjNf(value);
      setIdnfedescarganf(value.idnfe);

      // setInitialXMLs(value);

      // setInitialXMLs((state) => ({
      //   ...state,
      //   ...value
      // }));

      // setVolume(Number(value?.qcomnfe));
      // setPrice(Number(value?.vuncomnfe));

      setVolumeXML(Number(value?.qcomnfe));
      setPriceXML(Number(value?.vuncomnfe));

      formRef.current.setFieldValue('placactdescarganf', value.veictranspnfe);
      formRef.current.setFieldValue(
        'cnpjdistribuidoradescarganf',
        value.cnpjdistribuidoranfe
      );
      formRef.current.setFieldValue(
        'volumenfdescarganf',
        Number(value?.qcomnfe)
      );
      formRef.current.setFieldValue(
        'precounitariodescarganf',
        Number(value?.vuncomnfe)
      );
      formRef.current.setFieldValue(
        'cnpjtransportadoradescarganf',
        value?.cnpjtransportadoranfe
      );
      formRef.current.setFieldValue('idproduto', value?.idproduto);
      formRef.current.setFieldValue(
        'emissaonfe',
        moment(value?.emissaonfe).format('DD/MM/YYYY HH:mm')
      );

      formRefXML.current.setFieldValue(
        'placactdescarganf',
        value.veictranspnfe
      );
      formRefXML.current.setFieldValue(
        'cnpjdistribuidoradescarganf',
        value.cnpjdistribuidoranfe
      );
      formRefXML.current.setFieldValue(
        'volumenfdescarganf',
        Number(value?.qcomnfe)
      );
      formRefXML.current.setFieldValue(
        'precounitariodescarganf',
        Number(value?.vuncomnfe)
      );
      formRefXML.current.setFieldValue(
        'cnpjtransportadoradescarganf',
        value?.cnpjtransportadoranfe
      );
      formRefXML.current.setFieldValue('idproduto', value?.idproduto);
      formRefXML.current.setFieldValue(
        'emissaonfe',
        moment(value?.emissaonfe).format('DD/MM/YYYY HH:mm')
      );

      if (
        !isUndefined(value?.calculodensidadeproduto) &&
        value?.calculodensidadeproduto > 0
      ) {
        setCalculodensidadeproduto(value?.calculodensidadeproduto);
      } else {
        setCalculodensidadeproduto(value?.calculodensidadeproduto);
        handleLimpaVolume20NF();
      }

      setLeuNF(true);
    } else {
      setNfdescarganf('');
      setStatusLeituraNF('naoLeuNF');
      setIdnfedescarganf('');
    }
  }, []);

  useEffect(() => {
    if (leuNF) {
      formRef.current.setFieldValue('placactdescarganf', objNf?.veictranspnfe);
      formRef.current.setFieldValue(
        'cnpjdistribuidoradescarganf',
        objNf?.cnpjdistribuidoranfe
      );
      formRef.current.setFieldValue(
        'volumenfdescarganf',
        Number(objNf?.qcomnfe)
      );
      formRef.current.setFieldValue(
        'precounitariodescarganf',
        Number(objNf?.vuncomnfe)
      );
      formRef.current.setFieldValue(
        'cnpjtransportadoradescarganf',
        objNf?.cnpjtransportadoranfe
      );
      formRef.current.setFieldValue('idproduto', objNf?.idproduto);
      formRef.current.setFieldValue(
        'dataemissaonfdescarganf',
        moment(objNf?.emissaonfe).format('DD/MM/YYYY HH:mm')
      );

      formRefXML.current.setFieldValue(
        'placactdescarganf',
        objNf?.veictranspnfe
      );
      formRefXML.current.setFieldValue(
        'cnpjdistribuidoradescarganf',
        objNf?.cnpjdistribuidoranfe
      );
      formRefXML.current.setFieldValue(
        'volumenfdescarganf',
        Number(objNf?.qcomnfe)
      );
      formRefXML.current.setFieldValue(
        'precounitariodescarganf',
        Number(objNf?.vuncomnfe)
      );
      formRefXML.current.setFieldValue(
        'cnpjtransportadoradescarganf',
        objNf?.cnpjtransportadoranfe
      );
      formRefXML.current.setFieldValue('idproduto', objNf?.idproduto);
      formRefXML.current.setFieldValue(
        'dataemissaonfdescarganf',
        moment(objNf?.emissaonfe).format('DD/MM/YYYY HH:mm')
      );

      setVolumeXML(Number(objNf?.qcomnfe));
      setPriceXML(Number(objNf?.vuncomnfe));

      // setVolume(Number(initial?.volumenfdescarganf));
      // setPrice(Number(initial?.precounitariodescarganf));

      if (
        !isUndefined(objNf?.calculodensidadeproduto) &&
        objNf?.calculodensidadeproduto > 0
      ) {
        setCalculodensidadeproduto(objNf?.calculodensidadeproduto);
      } else {
        setCalculodensidadeproduto(objNf?.calculodensidadeproduto);
        handleLimpaVolume20NF();
      }
    }
  }, [objNf, leuNF]);

  const handleVerificarNFEOutroDestinatario = React.useCallback(
    async (nfnfe) => {
      try {
        const { data } = await api.get(
          `notafiscalrecebida/verificarnfeoutrodestinatario/${nfnfe}`
        );

        // console.log(JSON.stringify(data));

        if (data.statusnfe !== 'L') {
          toast.error(
            `Nfe está em uso por outro detinatário! ${data.destinatario.nomedestinatarionfe}`
          );
        }

        if (data.destinatario.nomedestinatarionfe) {
          toast.error(
            `Nfe é de outro detinatário! ${data.destinatario.nomedestinatarionfe}`
          );
        } else {
          setNfdescarganf(nfnfe);
          setOpenAceitaSemNotaFiscal(true);
          await formRef.current.setFieldValue('nfdescarganf', nfnfe);
        }
      } catch (err) {
        setNfdescarganf(nfnfe);
        setOpenAceitaSemNotaFiscal(true);
        await formRef.current.setFieldValue('nfdescarganf', nfnfe);
      } finally {
      }
    },
    []
  );

  useEffect(() => {
    if (statusLeituraNF === 'leuNFManual') {
      setVersion('version5');
    } else if (statusLeituraNF === 'leuUmaNF') {
      setVersion('version5');
      // setVersion('version6')
    } else if (can(MODULONFE) && controlanfeclienteconfig === 'S') {
      setVersion('version5');
    } else {
      setVersion('version4');
    }
  }, [statusLeituraNF, controlanfeclienteconfig, MODULONFE]);

  if (loading) return <></>;
  return (
    <>
      <Dialog
        disableEscapeKeyDown
        disableBackdropClick
        open={open}
        fullScreen={window.innerWidth <= 450 ? window.innerWidth <= 450 : false}
        maxWidth={window.innerWidth <= 450 ? 0 <= 450 : 'xl'}
        // maxWidth="xl"
        onExit={handleCallbackClose}
      >
        <DialogTitle>
          {t('s.menu.operacao.checkxmlnfrecebimentonf')}
        </DialogTitle>

        {/* {JSON.stringify(receivement)} */}
        {/* {JSON.stringify(permitirselecionarmaisdeumtanquenorecebimentoclienteconfig)}
        {JSON.stringify(permitirselecionarmaisdeumcompartimentonorecebimentoclienteconfig)}
        {JSON.stringify(permitirrecebimentosemumxmlnosistemaclienteconfig)} */}

        <DialogContent>
          <FormUI>
            <Input
              name="codigono"
              disabled
              label={t('s.configuracao.arqueacao.idposto')}
              defaultValue={formEdit?.codigonomeposto}
            />
          </FormUI>

          <FormUI
            ref={formRefXML}
            initialData={{ initialXMLs }}
            onSubmit={handleSubmit}
          >
            {/* INICIO CABECALHO */}
            <Accordion
              expanded={expanded === 'nf'}
              onChange={() => handleChangeAccordion('nf')}
            >
              <AccordionSummary
                expandIcon={receivement !== 2 && <ExpandMore />}
              >
                <Typography>
                  {t('Nota Fiscal Eletrônica recebido na integração')}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <S.AccordionDetailsNF>
                  <S.WrapperNF applyMargin version={version}>
                    <PesquisaTabelaInput
                      name="nfdescarganf"
                      userSelectFilterCountMaisQueUm
                      // onRow={(value) => console.log(JSON.stringify(value))}
                      onCallbackNaoEncotrado={(value) =>
                        handleInputAceitaSemNotaFiscal(value)
                      }
                      onCallbackConfirmado={(value) =>
                        handleInputNotaFiscal(value)
                      }
                      onCallbackCampoLimpo={() => handleInputLimpoNotaFiscal()}
                      onCallbackDesabilitaClearInputAtive={() =>
                        handleallbackDesabilitaClearInputAtive()
                      }
                      label={t('s.operacao.recebimentonf.nfdescarganf')}
                      primary="nfnfe"
                      url="notafiscalrecebida/disponivel"
                      header={nfeHeading}
                      // getValue={(value) => setObjNf(value)}

                      disabledDigitacao
                      // disabledDigitacao={
                      //   !(
                      //     permitirrecebimentosemumxmlnosistemaclienteconfig ===
                      //     'S'
                      //   )
                      // }
                      filterByUser
                      desabilitaPesquisaInput={
                        statusLeituraNF === 'leuNFManual'
                      }
                      desabilitaClearInputAtive={desabilitaClearInputAtive}
                      query={{
                        wherefield: ['cnpjdestinatarionfe'],
                        typewherefield: ['EQUALS'],
                        valuewherefield: [cnpjPosto],
                        pesquisalista: ['true'],
                      }}
                    />

                    {leuNF && (
                      <>
                        <Input
                          name="idproduto"
                          variant="outlined"
                          size="small"
                          label={t('s.menu.configuracao.produto')}
                          value={objNf?.nomeproduto}
                          disabled
                        />
                        {/* </>
                          )} */}

                        <Input
                          name="numeropedidodescarganf"
                          label={t(
                            's.operacao.recebimentonf.numeropedidodescarganf'
                          )}
                          defaultValue={initials.numeropedidodescarganf}
                        />

                        <Input
                          name="placactdescarganf"
                          label={t(
                            's.operacao.recebimentonf.placactdescarganf'
                          )}
                          defaultValue={objNf.veictranspnfe}
                        />

                        <Input
                          name="motoristadescarganf"
                          label={t(
                            's.operacao.recebimentonf.motoristadescarganf'
                          )}
                          defaultValue={initials.motoristadescarganf}
                        />

                        {statusLeituraNF === 'leuUmaNF' && (
                          <Input
                            name="cnpjdistribuidoradescarganf"
                            label={t(
                              's.operacao.recebimentonf.cnpjdistribuidoradescarganf'
                            )}
                            defaultValue={
                              idnfedescarganf !== ''
                                ? objNf.cnpjdistribuidoranfe
                                : initials.cnpjdistribuidoradescarganf
                            }
                            disabled={
                              isFinalizado ||
                              statusLeituraNF === 'leuUmaNF' ||
                              initials.comnfedescarganf === 'S'
                            }
                          />
                        )}

                        {statusLeituraNF === 'leuUmaNF' && (
                          <Input
                            name="cnpjtransportadoradescarganf"
                            label={t(
                              's.operacao.recebimentonf.cnpjtransportadoradescarganf'
                            )}
                            defaultValue={
                              idnfedescarganf !== ''
                                ? objNf.cnpjtransportadoranfe
                                : initials.cnpjtransportadoradescarganf
                            }
                            disabled={
                              isFinalizado ||
                              statusLeituraNF === 'leuUmaNF' ||
                              initials.comnfedescarganf === 'S'
                            }
                          />
                        )}

                        {statusLeituraNF === 'leuUmaNF' && (
                          <Input
                            name="dataemissaonfdescarganf"
                            value={moment(objNf?.emissaonfe).format(
                              'DD/MM/YYYY'
                            )}
                            label={t(
                              's.operacao.recebimentonf.dataemissaonfdescarganf'
                            )}
                            disabled
                          />
                        )}
                        {statusLeituraNF === 'leuUmaNF' && (
                          <Input
                            name="volumenfdescarganf"
                            label={t(
                              's.operacao.recebimentonf.volumenfdescarganf'
                            )}
                            type="number"
                            getValue={(value) => setVolume(Number(value))}
                            defaultValue={
                              idnfedescarganf !== ''
                                ? Number(objNf.qcomnfe)
                                : Number(initialXML.volumenfdescarganf)
                            }
                            disabled={
                              isFinalizado ||
                              statusLeituraNF === 'leuUmaNF' ||
                              initialXML.comnfedescarganf === 'S'
                            }
                          />
                        )}

                        {statusLeituraNF === 'leuUmaNF' && (
                          <Input
                            name="precounitariodescarganf"
                            label={t(
                              's.operacao.recebimentonf.precounitariodescarganf'
                            )}
                            type="number"
                            getValue={(value) => setPrice(Number(value))}
                            defaultValue={
                              idnfedescarganf !== ''
                                ? Number(objNf.vuncomnfe)
                                : Number(initialXML.precounitariodescarganf)
                            }
                            disabled={
                              isFinalizado ||
                              statusLeituraNF === 'leuUmaNF' ||
                              initialXML.comnfedescarganf === 'S'
                            }
                          />
                        )}

                        <Input
                          disabled
                          name="precototaldescarganf"
                          label={t(
                            's.operacao.recebimentonf.precototaldescarganf'
                          )}
                          value={number(totalXML, 2)}
                        />
                      </>
                    )}
                  </S.WrapperNF>

                  {/* <pre>{JSON.stringify({ habOper20, calculodensidadeproduto, habCompartments, compartimentos, tanques, initials }, null, 2)}</pre> */}
                </S.AccordionDetailsNF>
              </AccordionDetails>
            </Accordion>

            {/* FIM CABECALHO */}
          </FormUI>

          {/* {JSON.stringify(formEdit)} */}

          {/* DADOS DOS ATUAL */}

          <FormUI
            ref={formRef}
            initialData={isEmpty(formEdit) ? {} : initials}
            // onSubmit={handleSubmit}
          >
            <Accordion
              expanded={expanded === 'nf'}
              onChange={() => handleChangeAccordion('nf')}
            >
              <AccordionSummary
                expandIcon={receivement !== 2 && <ExpandMore />}
              >
                <Typography>
                  {t('s.operacao.recebimentonf.dadosdanf')}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <S.AccordionDetailsNF>
                  <S.WrapperNF applyMargin version={version}>
                    <Autocomplete
                      name="idposto"
                      label="codigonomeposto"
                      url="postos"
                      unique="idposto"
                      title={t('s.configuracao.arqueacao.idposto')}
                      hiddens={[{ name: 'tipodescargaposto' }]}
                      disabled={isFinalizado || receivement === 1}
                      getValue={({
                        tipodescargaposto,
                        operrecebimento20posto,
                        controla20grausposto,
                        opercompartimentosposto,
                        habilitafotonotafiscalposto,
                        habilitainspesaodescargaposto,
                        cnpjposto,
                        operamostracompartimentossemreceb20posto,
                        habilitaskidposto,
                      }) => {
                        setTypeTank(tipodescargaposto);

                        setHabReceipt(
                          operrecebimento20posto === 1 ||
                            operamostracompartimentossemreceb20posto === 1
                        );
                        setHabOper20(
                          operrecebimento20posto === 1 &&
                            controla20grausposto === 1
                        );
                        setHabCompartments(opercompartimentosposto === 1);

                        setOperamostracompartimentossemreceb20(
                          operamostracompartimentossemreceb20posto === 1
                        );

                        setHabHabilitafotonotafiscalposto(
                          habilitafotonotafiscalposto === 'S'
                        );

                        setHabilitaInspesaoDescargaPosto(
                          habilitainspesaodescargaposto === 'S'
                        );

                        setStatusHabilitaSkidPosto(habilitaskidposto === 'S');

                        /** */

                        if (
                          can(MODULONFE) &&
                          controlanfeclienteconfig === 'S'
                        ) {
                          if (receivement !== 1) {
                            setCalculodensidadeproduto(0);
                            setVolume(0);
                            setPrice(0);
                            // console.log('codigonomeposto')
                          }

                          setNfdescarganf('');
                          setStatusLeituraNF('');
                          setLeuNF(false);
                          setDesabilitaClearInputAtive(true);
                          if (!isUndefined(cnpjposto) && !isEmpty(cnpjposto)) {
                            const cnpj = removerMascaraCNPJ(cnpjposto);
                            setCnpjPosto(cnpj);
                          } else {
                            setCnpjPosto('0');
                          }
                          setIdnfedescarganf('');
                        }
                      }}
                    />

                    {!isFinalizado &&
                      can(MODULONFE) &&
                      controlanfeclienteconfig === 'S' &&
                      receivement === 2 && (
                        <PesquisaTabelaInput
                          name="nfdescarganf"
                          userSelectFilterCountMaisQueUm
                          // onRow={(value) => console.log(JSON.stringify(value))}
                          onCallbackNaoEncotrado={(value) =>
                            handleInputAceitaSemNotaFiscal(value)
                          }
                          onCallbackConfirmado={(value) =>
                            handleInputNotaFiscal(value)
                          }
                          onCallbackCampoLimpo={() =>
                            handleInputLimpoNotaFiscal()
                          }
                          onCallbackDesabilitaClearInputAtive={() =>
                            handleallbackDesabilitaClearInputAtive()
                          }
                          label={t('s.operacao.recebimentonf.nfdescarganf')}
                          primary="nfnfe"
                          url="notafiscalrecebida/disponivel"
                          header={nfeHeading}
                          // getValue={(value) => setObjNf(value)}

                          disabledDigitacao={
                            !(
                              permitirrecebimentosemumxmlnosistemaclienteconfig ===
                              'S'
                            )
                          }
                          filterByUser
                          desabilitaPesquisaInput={
                            statusLeituraNF === 'leuNFManual'
                          }
                          desabilitaClearInputAtive={desabilitaClearInputAtive}
                          query={{
                            wherefield: ['cnpjdestinatarionfe'],
                            typewherefield: ['EQUALS'],
                            valuewherefield: [cnpjPosto],
                            pesquisalista: ['true'],
                          }}
                        />
                      )}

                    {!isFinalizado &&
                      can(MODULONFE) &&
                      controlanfeclienteconfig === 'S' && (
                        <>
                          {leuNF && receivement !== 2 && (
                            <Input
                              name="nfdescarganf"
                              label={t('s.operacao.recebimentonf.nfdescarganf')}
                              disabled
                              value={nfdescarganf}
                            />
                          )}

                          {!leuNF && receivement !== 2 && (
                            // <Hidden name='nfdescarganf' key='nfdescarganf' />
                            <Input
                              name="nfdescarganf"
                              label={t('s.operacao.recebimentonf.nfdescarganf')}
                              disabled
                            />
                          )}
                        </>
                      )}

                    {(isFinalizado ||
                      !can(MODULONFE) ||
                      controlanfeclienteconfig === 'N') && (
                      <Input
                        name="nfdescarganf"
                        label={t('s.operacao.recebimentonf.nfdescarganf')}
                        disabled={isFinalizado}
                      />
                    )}

                    {(!can(MODULONFE) ||
                      controlanfeclienteconfig === 'N' ||
                      isFinalizado ||
                      leuNF ||
                      (receivement === 1 && statusRecebimento === 1) ||
                      (receivement === 1 && statusRecebimento === 2)) && (
                      <>
                        {/* {statusLeituraNF !== 'leuUmaNF' && ( */}
                        <Autocomplete
                          name="idproduto"
                          label="nomeproduto"
                          url="produtos"
                          unique="idproduto"
                          title={t('s.menu.configuracao.produto')}
                          disabled={isFinalizado || receivement === 1}
                          getValue={({ calculodensidadeproduto }) => {
                            if (
                              !isUndefined(calculodensidadeproduto) &&
                              calculodensidadeproduto > 0
                            ) {
                              setCalculodensidadeproduto(
                                calculodensidadeproduto
                              );
                            } else {
                              setCalculodensidadeproduto(
                                calculodensidadeproduto
                              );
                              handleLimpaVolume20NF();
                            }
                          }}
                        />

                        <Input
                          name="numeropedidodescarganf"
                          disabled={isFinalizado}
                          label={t(
                            's.operacao.recebimentonf.numeropedidodescarganf'
                          )}
                        />

                        <Input
                          name="placactdescarganf"
                          label={t(
                            's.operacao.recebimentonf.placactdescarganf'
                          )}
                          disabled={isFinalizado}
                          defaultValue={initials.placactdescarganf}
                        />

                        <Input
                          name="motoristadescarganf"
                          disabled={isFinalizado}
                          label={t(
                            's.operacao.recebimentonf.motoristadescarganf'
                          )}
                        />

                        {/* {statusLeituraNF !== 'leuUmaNF' && ( */}
                        <Autocomplete
                          name="cnpjdistribuidoradescarganf"
                          label="cnpjnomedistribuidoranfe"
                          url="distribuidorasnfes"
                          unique="cnpjdistribuidoranfe"
                          title={t(
                            's.operacao.recebimentonf.cnpjdistribuidoradescarganf'
                          )}
                          disabled={
                            isFinalizado ||
                            statusLeituraNF === 'leuUmaNF' ||
                            initials.comnfedescarganf === 'S'
                          }
                        />

                        <Autocomplete
                          name="cnpjtransportadoradescarganf"
                          label="cnpjnometransportadoranfe"
                          url="transportadorasnfes"
                          unique="cnpjtransportadoranfe"
                          title={t(
                            's.operacao.recebimentonf.cnpjtransportadoradescarganf'
                          )}
                          disabled={
                            isFinalizado ||
                            statusLeituraNF === 'leuUmaNF' ||
                            initials.comnfedescarganf === 'S'
                          }
                        />
                        {/* {statusLeituraNF !== 'leuUmaNF' && ( */}
                        <DateTime
                          name="dataemissaonfdescarganf"
                          label={t(
                            's.operacao.recebimentonf.dataemissaonfdescarganf'
                          )}
                          disabled={
                            isFinalizado || initials.comnfedescarganf === 'S'
                          }
                        />

                        <Input
                          name="volumenfdescarganf"
                          label={t(
                            's.operacao.recebimentonf.volumenfdescarganf'
                          )}
                          type="number"
                          getValue={(value) => setVolume(Number(value))}
                          defaultValue={Number(initials.volumenfdescarganf)}
                          disabled={
                            isFinalizado ||
                            statusLeituraNF === 'leuUmaNF' ||
                            initials.comnfedescarganf === 'S'
                          }
                        />

                        <Input
                          name="precounitariodescarganf"
                          label={t(
                            's.operacao.recebimentonf.precounitariodescarganf'
                          )}
                          type="number"
                          getValue={(value) => setPrice(Number(value))}
                          defaultValue={Number(
                            initials.precounitariodescarganf
                          )}
                          disabled={
                            isFinalizado ||
                            statusLeituraNF === 'leuUmaNF' ||
                            initials.comnfedescarganf === 'S'
                          }
                        />

                        <Input
                          disabled
                          name="precototaldescarganf"
                          label={t(
                            's.operacao.recebimentonf.precototaldescarganf'
                          )}
                          value={number(total, 2)}
                        />
                      </>
                    )}

                    {can(CUSTOMIZACAO_RAIZEN) && (
                      <Select
                        name="tipodescarganf"
                        label={t('s.cadastro.veiculo.tipoveiculo')}
                        options={[
                          { value: '1', label: 'Não DCM' },
                          { value: '2', label: 'DCM' },
                        ]}
                        disabled={isFinalizado}
                      />
                    )}
                  </S.WrapperNF>

                  <S.WrapperNF>
                    {habOper20 && Number(calculodensidadeproduto) >= 1 && (
                      <>
                        <Input
                          disabled={isFinalizado || !habOper20}
                          name="densidade20nftbdescarganf"
                          type="number"
                          label={t(
                            's.operacao.recebimento.densidade20nftbdescarganf'
                          )}
                          getValue={(value) => {
                            // if (value < 2) {
                            setDensidade20NF(Number(value));
                            // } else {
                            //  setDensidade20NF(0)
                            // }
                          }}
                          onBlur={() => setNecessarioBtnSalvar(true)}
                          onKeyDown={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;

                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                              // return true;
                            } else if (
                              charCode === 109 ||
                              charCode === 107 ||
                              charCode === 189 ||
                              charCode === 16
                            ) {
                              event.preventDefault();
                              event.target.value = '0';
                              return false;
                            }
                          }}
                          onKeyUp={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;
                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                            } else {
                            }
                          }}
                        />

                        <Input
                          disabled={isFinalizado || !habOper20}
                          type="number"
                          name="temperaturanftbdescarganf"
                          label={t(
                            's.operacao.recebimento.temperaturanftbdescarganf'
                          )}
                          getValue={(value) => {
                            // if (Number(value) < 99) {
                            setTemperaturaNF(Number(value));
                            // } else {
                            //  setTemperaturaNF(0)
                            // }
                          }}
                          onBlur={() => setNecessarioBtnSalvar(true)}
                          onKeyDown={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;
                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                            } else {
                              //
                              if (
                                charCode === 109 ||
                                charCode === 107 ||
                                charCode === 189 ||
                                charCode === 16
                              ) {
                                event.preventDefault();
                                event.target.value = '0';
                                return false;
                              }
                            }
                          }}
                          onKeyUp={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;
                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                            } else {
                            }
                            if (event.key === 'Enter') {
                              // console.log(event.target.value);
                            }
                          }}
                        />

                        <Input
                          disabled
                          name="volume20nftbdescarganf"
                          label={t(
                            's.operacao.recebimento.volume20nftbdescarganf'
                          )}
                          value={number(volume20, 0)}
                          getValue={(value) => setVolume20(Number(value))}
                          onBlur={() => setNecessarioBtnSalvar(true)}
                        />
                      </>
                    )}

                    {habCompartments && can(SKID) && (
                      <Hidden name="numerocompartimentosdescarganf" value="1" />
                    )}
                    {habCompartments && !can(SKID) && (
                      <Input
                        disabled={
                          isFinalizado || !habCompartments || receivement === 1
                        }
                        name="numerocompartimentosdescarganf"
                        type="number"
                        label={t('s.operacao.recebimento.numerocompartimentos')}
                        getValue={(value) =>
                          setNumberCompartments(Number(value))
                        }
                        // onBlur={() => setNecessarioBtnSalvar(true)}
                      />
                    )}
                  </S.WrapperNF>

                  <S.WrapperNF>
                    {((receivement === 2 &&
                      statusRecebimento === RECEBIMENTO_READ_ONLY) ||
                      (receivement === 1 &&
                        statusRecebimento === RECEBIMENTO_SELECT_TANKS)) && (
                      <DateTime
                        nullable
                        time
                        name="datahorainiciodescarganf"
                        label={t(
                          's.operacao.recebimentonf.datahorainiciodescarganf'
                        )}
                        value={
                          isEmpty(initials.datahorainiciodescarganf)
                            ? null
                            : moment(
                                initials.datahorainiciodescarganf,
                                'DD/MM/YYYY HH:mm:ss'
                              )
                        }
                        disabled={habilitaDtaCampoInicio !== true}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            datahorainiciodescarganf: value,
                          }))
                        }
                      />
                    )}

                    {receivement === 1 &&
                      statusRecebimento === RECEBIMENTO_WAIT_FINISH && (
                        <Input
                          name="datahorainiciodescarganf"
                          value={initials.datahorainiciodescarganf}
                          label={t(
                            's.operacao.recebimentonf.datahorainiciodescarganf'
                          )}
                          disabled
                        />
                      )}

                    {receivement === 1 &&
                      statusRecebimento === RECEBIMENTO_WAIT_FINISH && (
                        <DateTime
                          nullable
                          time
                          name="datahorafimdescarganf"
                          label={t(
                            's.operacao.recebimentonf.datahorafimdescarganf'
                          )}
                          disabled={
                            !(
                              (typeTank === 1 &&
                                statusRecebimento !==
                                  RECEBIMENTO_WAIT_FINISH) ||
                              habilitaDtaCampoFim === true
                            )
                          }
                          getValue={(value) =>
                            setInitials((state) => ({
                              ...state,
                              datahorafimdescarganf: value,
                            }))
                          }
                        />
                      )}

                    {!isFinalizado && typeTank === 2 && (
                      <DateTime
                        nullable
                        time
                        name="datahorafimdescarganf"
                        label={t(
                          's.operacao.recebimentonf.datahorafimdescarganf'
                        )}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            datahorafimdescarganf: value,
                          }))
                        }
                      />
                    )}

                    {/* //05-05-2025  novo para visualizar */}
                    {isFinalizado && (
                      <>
                        <Input
                          name="datahorainiciodescarganf"
                          value={initials.datahorainiciodescarganf}
                          label={t(
                            's.operacao.recebimentonf.datahorainiciodescarganf'
                          )}
                          disabled
                        />
                        <Input
                          name="datahorafimdescarganf"
                          value={initials.datahorafimdescarganf}
                          label={t(
                            's.operacao.recebimentonf.datahorafimdescarganf'
                          )}
                          disabled
                        />
                      </>
                    )}
                  </S.WrapperNF>

                  {/* <pre>{JSON.stringify({ habOper20, calculodensidadeproduto, habCompartments, compartimentos, tanques, initials }, null, 2)}</pre> */}
                </S.AccordionDetailsNF>
              </AccordionDetails>
            </Accordion>

            {receivement === 1 &&
              habReceipt &&
              habCompartments &&
              Number(calculodensidadeproduto) >= 1 && (
                <Accordion
                  expanded={expanded === 'sample'}
                  onChange={() => handleChangeAccordion('sample')}
                >
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography>
                      {t('s.operacao.recebimentonf.sample')}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <S.Wrapper>
                      <S.WrapperGroupSample>
                        <Input
                          disabled={isFinalizado}
                          // disabled={isFinalizado || !habOper20}
                          name="compartimentoamostradescarganf"
                          type="number"
                          getValue={(value) =>
                            setInitials((state) => ({
                              ...state,
                              compartimentoamostradescarganf: Number(value),
                            }))
                          }
                          InputProps={{
                            inputProps: {
                              pattern: '[0-9]*',
                              maxLength: 2,
                              max: 16,
                              min: 1,
                            },
                          }}
                          onBlur={() => setNecessarioBtnSalvar(true)}
                          onKeyDown={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;

                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                            } else {
                              if (
                                charCode === 110 ||
                                charCode === 109 ||
                                charCode === 107 ||
                                charCode === 188 ||
                                charCode === 189 ||
                                charCode === 190 ||
                                charCode === 16
                              ) {
                                event.preventDefault();
                                event.target.value = '0';
                                return false;
                              }
                              if (Number(event.target.value) > 16) {
                                event.preventDefault();
                                event.target.value = '';
                                const validationErrors = {
                                  compartimentoamostradescarganf: `Valor máxima permitido ${numberCompartments}`,
                                };
                                if (formRef) {
                                  if (formRef.current) {
                                    formRef.current.setErrors(validationErrors);
                                  }
                                }
                                return false;
                              }
                              if (
                                Number(event.target.value) > numberCompartments
                              ) {
                                event.preventDefault();
                                event.target.value = '';
                                const validationErrors = {
                                  compartimentoamostradescarganf: `Valor máxima permitido ${numberCompartments}`,
                                };

                                if (formRef) {
                                  if (formRef.current) {
                                    formRef.current.setErrors(validationErrors);
                                  }
                                }
                                return false;
                              }
                              const validationErrors = {
                                ...formRef.current.getErrors(),
                                compartimentoamostradescarganf: '',
                              };
                              if (formRef) {
                                if (formRef.current) {
                                  formRef.current.setErrors(validationErrors);
                                }
                              }
                            }
                          }}
                          onKeyUp={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;

                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                            } else {
                              if (Number(event.target.value) > 16) {
                                event.preventDefault();
                                event.target.value = '';
                                const validationErrors = {
                                  ...formRef.current.getErrors(),
                                  compartimentoamostradescarganf: `Valor máxima permitido ${numberCompartments}`,
                                };
                                if (formRef) {
                                  if (formRef.current) {
                                    formRef.current.setErrors(validationErrors);
                                  }
                                }
                                return false;
                              }
                              if (
                                Number(event.target.value) > numberCompartments
                              ) {
                                event.preventDefault();
                                event.target.value = '';
                                const validationErrors = {
                                  ...formRef.current.getErrors(),
                                  compartimentoamostradescarganf: `Valor máxima permitido ${numberCompartments}`,
                                };
                                if (formRef) {
                                  if (formRef.current) {
                                    formRef.current.setErrors(validationErrors);
                                  }
                                }
                                return false;
                              }
                              const validationErrors = {
                                ...formRef.current.getErrors(),
                                compartimentoamostradescarganf: '',
                              };
                              if (formRef) {
                                if (formRef.current) {
                                  formRef.current.setErrors(validationErrors);
                                }
                              }
                            }
                            if (event.key === 'Enter') {
                              // console.log(event.target.value);
                            }
                          }}
                          label={t(
                            's.operacao.recebimento.compartimentoamostratbdescarganf'
                          )}
                        />

                        <Input
                          disabled={isFinalizado}
                          // disabled={isFinalizado || !habOper20}
                          name="temperaturaamostratbdescarganf"
                          getValue={(value) => {
                            setTemperaturaamostra(Number(value));

                            setInitials((state) => ({
                              ...state,
                              temperaturaamostratbdescarganf: Number(value),
                            }));
                          }}
                          // getValue={
                          //   (value) => setTemperaturaamostra(Number(value))
                          // }

                          type="number"
                          label={t(
                            's.operacao.recebimento.temperaturaamostratbdescarganf'
                          )}
                          onBlur={() => setNecessarioBtnSalvar(true)}
                          onKeyDown={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;
                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                            } else if (
                              charCode === 109 ||
                              charCode === 107 ||
                              charCode === 189 ||
                              charCode === 16
                            ) {
                              event.preventDefault();
                              event.target.value = '0';
                              return false;
                            }
                          }}
                          onKeyUp={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;
                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                            } else {
                              // if (Number(event.target.value) > 99) {
                              //   event.preventDefault();
                              //   event.target.value = '0';
                              //   return false;
                              // }
                            }
                            if (event.key === 'Enter') {
                              // console.log(event.target.value);
                            }
                          }}
                        />

                        <Input
                          disabled={isFinalizado}
                          // disabled={isFinalizado || !habOper20}
                          name="densidadeambienteamostratbdescarganf"
                          type="number"
                          label={t(
                            's.operacao.recebimento.densidadeambienteamostratbdescarganf'
                          )}
                          // getValue={(value) => setDensidadeamostra(Number(value))}

                          getValue={(value) => {
                            setDensidadeamostra(Number(value));

                            setInitials((state) => ({
                              ...state,
                              densidadeambienteamostratbdescarganf: Number(
                                value
                              ),
                            }));
                          }}
                          onBlur={() => setNecessarioBtnSalvar(true)}
                          onKeyDown={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;
                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                              // return true;
                            } else {
                              if (
                                charCode === 109 ||
                                charCode === 107 ||
                                charCode === 189 ||
                                charCode === 16
                              ) {
                                event.preventDefault();
                                event.target.value = '0';
                                return false;
                              }
                              // if (Number(event.target.value) > 2) {
                              //   event.preventDefault();
                              //   event.target.value = '0';
                              //   return false;
                              // }
                            }
                          }}
                          onKeyUp={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;
                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                              // return true;
                            } else {
                              // if (Number(event.target.value) > 2) {
                              //   event.preventDefault();
                              //   event.target.value = '0';
                              //   return false;
                              // }
                            }
                            if (event.key === 'Enter') {
                              // console.log(event.target.value);
                              // handleAtualizaTemperaturaCompartimentos(event, compartimento.iddescarganfcompartimento, listaDeCompartimentos);
                            }
                          }}
                        />

                        <Input
                          disabled
                          name="densidade20amostradescarganf"
                          style={{ backgroundColor: '#dcdcdc' }}
                          label={t(
                            's.operacao.recebimento.densidade20amostratbdescarganf'
                          )}
                          value={
                            densidadecalculadaamostra20 > 0
                              ? densidadecalculadaamostra20
                              : ''
                          }
                        />
                      </S.WrapperGroupSample>
                    </S.Wrapper>
                  </AccordionDetails>
                </Accordion>
              )}

            {receivement === 1 && habCompartments && (
              <Accordion
                expanded={expanded === 'compartments'}
                onChange={() => handleChangeAccordion('compartments')}
              >
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Typography>
                    {t('s.operacao.recebimentonf.compartments')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TableCompartments
                    isFinalizado={isFinalizado}
                    idposto={initials.idposto}
                    idproduto={initials.idproduto}
                    status={statusRecebimento}
                    listaDeCompartimentos={compartimentos}
                    constrolsAt20={habReceipt}
                    densidadecalculadaamostra20={densidadecalculadaamostra20}
                    calculodensidadeproduto={calculodensidadeproduto}
                    onAtualizaCompartimentos={handleAtualizaCompartimentos}
                    onUpdateStatus={() =>
                      handleGetSummaryVL(
                        initials.iddescarganf,
                        initials.idposto
                      )
                    }
                  />
                </AccordionDetails>
              </Accordion>
            )}

            {receivement === 1 && (
              <Accordion
                expanded={expanded === 'tank'}
                onChange={() => handleChangeAccordion('tank')}
              >
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Typography>
                    {t('s.operacao.recebimentonf.tanques')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TabelaRecebimento
                    idposto={initials.idposto}
                    idproduto={initials.idproduto}
                    status={statusRecebimento}
                    listaDeTanques={tanques}
                    onAtualizaTanques={handleAtualizaTanques}
                    onUpdateStatus={() =>
                      handleGetSummaryVL(
                        initials.iddescarganf,
                        initials.idposto
                      )
                    }
                    permitirselecionarmaisdeumtanque={
                      permitirselecionarmaisdeumtanquenorecebimentoclienteconfig
                    }
                  />
                </AccordionDetails>
              </Accordion>
            )}

            {/* ---------- */}

            {receivement === 1 &&
              habHabilitafotonotafiscalposto &&
              can(MODULOFOTO) && (
                <Accordion
                  expanded={expanded === 'photo'}
                  onChange={() => handleChangeAccordion('photo')}
                >
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography>
                      {t('s.operacao.notafiscalrecebida.photo')}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <S.AccordionDetailsNF>
                      {/* ({JSON.stringify(jatiroufotodescarganf)}) */}
                      {jatiroufotodescarganf !== 'S' && (
                        <>
                          {isMobile && (
                            <ButtonBase
                              onClick={() => irParaFotoNF()}
                              style={{
                                borderRadius: 8,
                                padding: '8px 16px',
                                backgroundColor: '#f0f0f0',
                                transition: 'transform 0.1s, box-shadow 0.1s',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                width: '200px',
                                marginBottom: '16px', // Espaço entre os botões
                              }}
                              onMouseDown={(e) =>
                                (e.currentTarget.style.transform =
                                  'scale(0.95)')
                              }
                              onMouseUp={(e) =>
                                (e.currentTarget.style.transform = 'scale(1)')
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.transform = 'scale(1)')
                              }
                            >
                              <Typography variant="body2" color="primary">
                                Abrir Foto NF
                              </Typography>
                            </ButtonBase>
                          )}

                          <QRCode
                            style={{
                              height: 'auto',
                              maxWidth: '270px',
                              width: '100%',
                            }}
                            // value={`${window.location.host}/fotonf?id=${initials?.tokenuuiddescarganf}&token=${JSON.stringify(token?.token).replace(/^["']|["']$/g, '')}`}
                            value={`${appUrl}`}
                            viewBox="0 0 50 50"
                            // viewBox="0 0 256 256"
                          />
                        </>
                      )}

                      {jatiroufotodescarganf === 'S' && (
                        <S.WrapperNFFoto>
                          <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            gap={2} // Espaço entre os botões
                            p={2} // Padding interno do container
                          >
                            {/* {JSON.stringify(dataFotos)} */}

                            <ButtonBase
                              onClick={() =>
                                window.open(
                                  dataFotos?.urlfotofrentefotodescarganf,
                                  '_blank',
                                  'noopener,noreferrer'
                                )
                              }
                              style={{
                                borderRadius: 8,
                                padding: '8px 16px',
                                backgroundColor: '#f0f0f0',
                                transition: 'transform 0.1s, box-shadow 0.1s',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                width: '200px',
                                marginBottom: '16px', // Espaço entre os botões
                              }}
                              onMouseDown={(e) =>
                                (e.currentTarget.style.transform =
                                  'scale(0.95)')
                              }
                              onMouseUp={(e) =>
                                (e.currentTarget.style.transform = 'scale(1)')
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.transform = 'scale(1)')
                              }
                            >
                              <Typography variant="body2" color="primary">
                                Foto Frente
                              </Typography>
                            </ButtonBase>

                            <ButtonBase
                              onClick={() =>
                                window.open(
                                  dataFotos?.urlfotoversofotodescarganf,
                                  '_blank',
                                  'noopener,noreferrer'
                                )
                              }
                              style={{
                                borderRadius: 8,
                                padding: '8px 16px',
                                backgroundColor: '#f0f0f0',
                                transition: 'transform 0.1s, box-shadow 0.1s',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                width: '200px',
                                marginBottom: '16px', // Espaço entre os botões
                              }}
                              onMouseDown={(e) =>
                                (e.currentTarget.style.transform =
                                  'scale(0.95)')
                              }
                              onMouseUp={(e) =>
                                (e.currentTarget.style.transform = 'scale(1)')
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.transform = 'scale(1)')
                              }
                            >
                              <Typography variant="body2" color="primary">
                                Foto Verso
                              </Typography>
                            </ButtonBase>

                            <DeleteButtonWithModal
                              onDelete={() =>
                                handleDeleteFotos(
                                  dataFotos?.iddescarganf,
                                  dataFotos?.idposto
                                )
                              }
                              disabled={loading}
                            />
                          </Box>

                          {/* <S.WrapperNFFotoimagens> */}
                          <Typography variant="body2" color="primary">
                            Foto Frente
                            <img
                              src={dataFotos?.urlfotofrentefotodescarganf}
                              alt="Imagem do banco de dados"
                              style={{
                                width: '300px',
                                height: '300px',
                                marginRight: '16px',
                              }}
                            />
                          </Typography>
                          <Typography variant="body2" color="primary">
                            Foto Verso
                            <img
                              src={dataFotos?.urlfotoversofotodescarganf}
                              alt="Imagem do banco de dados"
                              style={{ width: '300px', height: '300px' }}
                            />
                          </Typography>
                          {/* </S.WrapperNFFotoimagens> */}
                        </S.WrapperNFFoto>
                      )}
                    </S.AccordionDetailsNF>
                  </AccordionDetails>
                </Accordion>
              )}

            {receivement === 1 && habilitaInspesaoDescargaPosto && (
              <Accordion
                expanded={expanded === 'Inspection'}
                onChange={() => handleChangeAccordion('Inspection')}
              >
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Typography>
                    {t('s.operacao.notafiscalrecebida.Inspection')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {/* <S.Wrapper> */}
                  {/* <S.WrapperGroupInspection> */}
                  <S.AccordionDetailsNF>
                    <S.WrapperNF applyMargin version="version4">
                      <DateTime
                        time
                        nullable
                        disableFuture
                        name="inspecao.inpsdataentradabdescarganfinspecao"
                        label={t(
                          's.operacao.notafiscalrecebida.inspecao.inpsdataentradabdescarganfinspecao'
                        )}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            inspecao: {
                              ...(state.inspecao || {}),
                              inpsdataentradabdescarganfinspecao: value,
                            },
                          }))
                        }
                        disabled={isFinalizado}
                      />

                      {/* {JSON.stringify(initials)} */}

                      <DateTime
                        time
                        nullable
                        disableFuture
                        name="inspecao.inpsdatasaidabdescarganfinspecao"
                        label={t(
                          's.operacao.notafiscalrecebida.inspecao.inpsdatasaidabdescarganfinspecao'
                        )}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            inspecao: {
                              ...(state.inspecao || {}),
                              inpsdatasaidabdescarganfinspecao: value,
                            },
                          }))
                        }
                        disabled={isFinalizado}
                      />

                      <Select
                        name="inspecao.inpslacresconferemdescarganfinspecao"
                        label={t(
                          's.operacao.notafiscalrecebida.inspecao.inpslacresconferemdescarganfinspecao'
                        )}
                        options={[
                          { value: 'N', label: t('s.geral.opcoes.nao') },
                          { value: 'S', label: t('s.geral.opcoes.sim') },
                        ]}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            inspecao: {
                              ...(state.inspecao || {}),
                              inpslacresconferemdescarganfinspecao: value,
                            },
                          }))
                        }
                        disabled={isFinalizado}
                      />

                      {initials?.inspecao
                        ?.inpslacresconferemdescarganfinspecao === 'S' && (
                        <Input
                          name="inspecao.inpslacresnumerodescarganfinspecao"
                          variant="outlined"
                          size="small"
                          inputProps={{ maxLength: 249 }}
                          label={t(
                            's.operacao.notafiscalrecebida.inspecao.inpslacresnumerodescarganfinspecao'
                          )}
                          getValue={(value) =>
                            setInitials((state) => ({
                              ...state,
                              inspecao: {
                                ...(state.inspecao || {}),
                                inpslacresnumerodescarganfinspecao: value,
                              },
                            }))
                          }
                          disabled={isFinalizado}
                        />
                      )}

                      <Select
                        name="inspecao.inspprodutosetadescarganfinspecao"
                        label={t(
                          's.operacao.notafiscalrecebida.inspecao.inspprodutosetadescarganfinspecao'
                        )}
                        options={[
                          { value: 'N', label: t('s.geral.opcoes.nao') },
                          { value: 'S', label: t('s.geral.opcoes.sim') },
                        ]}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            inspecao: {
                              ...(state.inspecao || {}),
                              inspprodutosetadescarganfinspecao: value,
                            },
                          }))
                        }
                        disabled={isFinalizado}
                      />

                      <Select
                        name="inspecao.inpsisentoaguaimpurezadescarganfinspecao"
                        label={t(
                          's.operacao.notafiscalrecebida.inspecao.inpsisentoaguaimpurezadescarganfinspecao'
                        )}
                        options={[
                          { value: 'N', label: t('s.geral.opcoes.nao') },
                          { value: 'S', label: t('s.geral.opcoes.sim') },
                        ]}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            inspecao: {
                              ...(state.inspecao || {}),
                              inpsisentoaguaimpurezadescarganfinspecao: value,
                            },
                          }))
                        }
                        disabled={isFinalizado}
                      />

                      <Select
                        name="inspecao.inpsvisualprodutodescarganfinspecao"
                        label={t(
                          's.operacao.notafiscalrecebida.inspecao.inpsvisualprodutodescarganfinspecao'
                        )}
                        options={[
                          { value: 'OK', label: t('s.geral.opcoes.ok') },
                          { value: 'NOK', label: t('s.geral.opcoes.nok') },
                        ]}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            inspecao: {
                              ...(state.inspecao || {}),
                              inpsvisualprodutodescarganfinspecao: value,
                            },
                          }))
                        }
                        disabled={isFinalizado}
                      />
                      <Select
                        name="inspecao.inpscompartimentovaziodescarganfinspecao"
                        label={t(
                          's.operacao.notafiscalrecebida.inspecao.inpscompartimentovaziodescarganfinspecao'
                        )}
                        options={[
                          { value: 'N', label: t('s.geral.opcoes.nao') },
                          { value: 'S', label: t('s.geral.opcoes.sim') },
                        ]}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            inspecao: {
                              ...(state.inspecao || {}),
                              inpscompartimentovaziodescarganfinspecao: value,
                            },
                          }))
                        }
                        disabled={isFinalizado}
                      />
                    </S.WrapperNF>
                  </S.AccordionDetailsNF>
                  {/* </S.Wrapper> */}
                </AccordionDetails>
              </Accordion>
            )}

            {includes(
              [RECEBIMENTO_WAIT_FINISH, RECEBIMENTO_READ_ONLY],
              statusRecebimento
            ) &&
              receivement === 1 &&
              habReceipt &&
              habOper20 &&
              Number(calculodensidadeproduto) >= 1 && (
                <Accordion
                  expanded={expanded === 'batch'}
                  onChange={() => handleChangeAccordion('batch')}
                >
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography>
                      {t('s.operacao.recebimentonf.batch')}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <TableBatch
                      idposto={initials.idposto}
                      idproduto={initials.idproduto}
                      status={statusRecebimento}
                      listaDeTanques={tanques}
                      constrolsAt20={habReceipt}
                      calculodensidadeproduto={calculodensidadeproduto}
                      onAtualizaTanques={handleAtualizaTanques}
                      onUpdateStatus={() =>
                        handleGetSummaryVL(
                          initials.iddescarganf,
                          initials.idposto
                        )
                      }
                      isFinalizado={isFinalizado}
                    />
                  </AccordionDetails>
                </Accordion>
              )}
          </FormUI>

          {includes(
            [RECEBIMENTO_WAIT_FINISH, RECEBIMENTO_READ_ONLY],
            statusRecebimento
          ) && (
            <S.WrapperSummary>
              <Typography>
                {t('s.operacao.recebimentonf.resumovolumerecebido')}
              </Typography>

              <S.WrapperGroupInputs>
                <TextField
                  disabled
                  fullWidth
                  label={t('s.operacao.recebimentonf.volumenfdescarganf')}
                  value={number(initials.volumenfdescarganf || volume, 0)}
                  size="small"
                  variant="outlined"
                />

                <TextField
                  disabled
                  fullWidth
                  label={t('s.operacao.recebimentonf.volumerec')}
                  value={number(tanquesVolumeRec, 0)}
                  size="small"
                  variant="outlined"
                />

                <TextField
                  disabled
                  fullWidth
                  label={t('s.operacao.recebimentonf.volAbastecido')}
                  value={number(resumoVolAbs, 0)}
                  size="small"
                  variant="outlined"
                />

                <TextField
                  disabled
                  fullWidth
                  label={t('s.operacao.recebimentonf.difnf')}
                  value={number(
                    tanquesVolumeRec +
                      resumoVolAbs -
                      (initials.volumenfdescarganf || volume),
                    0
                  )}
                  size="small"
                  variant="outlined"
                />

                {receivement === 1 && habCompartments && (
                  <TextField
                    disabled
                    fullWidth
                    label={t('Vol. Rec. Compartimentos')}
                    value={number(compartimentosVolumeRec, 0)}
                    size="small"
                    variant="outlined"
                  />
                )}

                {habOper20 && Number(calculodensidadeproduto) >= 1 && (
                  <>
                    <TextField
                      disabled
                      fullWidth
                      label={t('Volume 20 NF')}
                      value={number(volume20, 0)}
                      size="small"
                      variant="outlined"
                    />

                    {habCompartments && (
                      <TextField
                        disabled
                        fullWidth
                        label={t('Vol. 20 Rec. Compartimentos')}
                        value={number(compartimentosVolume20Rec, 0)}
                        size="small"
                        variant="outlined"
                      />
                    )}

                    {habCompartments && (
                      <TextField
                        disabled
                        fullWidth
                        label={t('Dif 20 (NF - Med Comp.)')}
                        value={number(volume20 - compartimentosVolume20Rec, 0)}
                        size="small"
                        variant="outlined"
                      />
                    )}
                  </>
                )}

                {can(SKID) && statusHabilitaSkidPosto === true && (
                  <>
                    <TextField
                      disabled
                      fullWidth
                      label={t('s.operacao.recebimentonf.skid.volumerecskid')}
                      value={number(volumeSkid, 0)}
                      size="small"
                      variant="outlined"
                    />
                    <TextField
                      disabled
                      fullWidth
                      label={t('s.operacao.recebimentonf.skid.difnfskid')}
                      value={number(
                        volumeSkid - initials.volumenfdescarganf,
                        0
                      )}
                      size="small"
                      variant="outlined"
                    />
                    {habOper20 && Number(calculodensidadeproduto) >= 1 && (
                      <TextField
                        disabled
                        fullWidth
                        label={t(
                          's.operacao.recebimentonf.skid.volume20recskid'
                        )}
                        value={number(volume20Skid, 0)}
                        size="small"
                        variant="outlined"
                      />
                    )}
                    <TextField
                      disabled
                      fullWidth
                      label={t('s.operacao.recebimentonf.skid.temperatura')}
                      value={number(temperaturaSkid, 1)}
                      size="small"
                      variant="outlined"
                    />
                    <TextField
                      disabled
                      fullWidth
                      label={t('s.operacao.recebimentonf.skid.densidade')}
                      value={number(densidadeSkid, 4)}
                      size="small"
                      variant="outlined"
                    />
                  </>
                )}
              </S.WrapperGroupInputs>
            </S.WrapperSummary>
          )}
        </DialogContent>
        <DialogActions>
          {/* 05-05-2025  novo para visualizar */}

          {leuNF && (
            <Button
              onClick={() => formRefXML.current.submitForm()}
              color="primary"
              variant="outlined"
              disabled={load}
            >
              {t('s.geral.botaosalvar')}
            </Button>
          )}

          <Button onClick={closeModal} color="secondary" variant="outlined">
            {t('s.geral.botaofechar')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal para verificar se aceita fazer o processo de recebimento sem a nota fiscal */}
      <Dialog
        disableEscapeKeyDown
        disableBackdropClick
        onClose={handleCloseAceitaSemNotaFiscal}
        aria-labelledby="customized-dialog-title"
        open={openAceitaSemNotaFiscal}
        fullScreen={window.innerWidth <= 450}
      >
        <DialogTitle id="customized-dialog-title">
          Aceita fazer o processo de recebimento sem a nota fiscal
          {/* {t('s.operacao.recebimentonf.selecionarnotafiscal')} */}
        </DialogTitle>
        <DialogContent dividers>
          Confirma fazer o processo de recebimento sem a nota fiscal?
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => handleConfirmaAceitaSemNotaFiscal()}
            color="primary"
            variant="outlined"
            disabled={load}
          >
            {t('s.geral.opcoes.sim')}
          </Button>
          <Button
            onClick={handleCloseAceitaSemNotaFiscal}
            color="secondary"
            variant="outlined"
            disabled={load}
          >
            {t('s.geral.opcoes.nao')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
});

Form.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  formEdit: PropTypes.objectOf(PropTypes.any),
};

Form.defaultProps = {
  formEdit: {},
};

export default Form;
